function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Theme } from "../../core/Theme";
import { percent, p50, p100 } from "../../core/util/Percent";
import { ColorSet } from "../../core/util/ColorSet";
import { setColor } from "../../themes/DefaultTheme";
import * as $time from "../../core/util/Time";
import * as $type from "../../core/util/Type";
import * as $math from "../../core/util/Math";
import * as $object from "../../core/util/Object";
import * as $array from "../../core/util/Array";
/**
 * @ignore
 */
export var XYChartDefaultTheme = /*#__PURE__*/function (_Theme) {
  _inherits(XYChartDefaultTheme, _Theme);
  var _super = _createSuper(XYChartDefaultTheme);
  function XYChartDefaultTheme() {
    _classCallCheck(this, XYChartDefaultTheme);
    return _super.apply(this, arguments);
  }
  _createClass(XYChartDefaultTheme, [{
    key: "setupDefaultRules",
    value: function setupDefaultRules() {
      var _this = this;
      _get(_getPrototypeOf(XYChartDefaultTheme.prototype), "setupDefaultRules", this).call(this);
      var ic = this._root.interfaceColors;
      var language = this._root.language;
      var r = this.rule.bind(this);
      /**
       * ========================================================================
       * charts/xy
       * ========================================================================
       */
      r("XYChart").setAll({
        colors: ColorSet.new(this._root, {}),
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 16,
        paddingBottom: 16,
        panX: false,
        panY: false,
        wheelStep: 0.25,
        arrangeTooltips: true,
        pinchZoomX: false,
        pinchZoomY: false
      });
      r("XYSeries").setAll({
        legendLabelText: "{name}"
      });
      /**
       * ------------------------------------------------------------------------
       * charts/xy: XYChartScrollbar
       * ------------------------------------------------------------------------
       */
      r("XYChart", ["scrollbar", "chart"]).setAll({
        paddingBottom: 0,
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        colors: ColorSet.new(this._root, {
          saturation: 0
        })
      });
      {
        var rule = r("Graphics", ["scrollbar", "overlay"]);
        rule.setAll({
          fillOpacity: 0.5
        });
        setColor(rule, "fill", ic, "background");
      }
      // Class: RoundedRectangle
      r("RoundedRectangle", ["xy", "scrollbar", "thumb"]).setAll({
        cornerRadiusTR: 0,
        cornerRadiusTL: 0,
        cornerRadiusBR: 0,
        cornerRadiusBL: 0,
        fillOpacity: 0,
        focusable: true
      });
      r("RoundedRectangle", ["xy", "scrollbar", "thumb"]).states.create("hover", {
        fillOpacity: 0.4
      });
      r("RoundedRectangle", ["xy", "scrollbar", "chart", "background"]).setAll({
        cornerRadiusTL: 0,
        cornerRadiusBL: 0,
        cornerRadiusTR: 0,
        cornerRadiusBR: 0
      });
      r("RoundedRectangle", ["xy", "scrollbar", "chart", "background", "resize", "button"]).setAll({
        cornerRadiusBL: 40,
        cornerRadiusBR: 40,
        cornerRadiusTL: 40,
        cornerRadiusTR: 40
      });
      r("AxisRendererX", ["xy", "chart", "scrollbar"]).setAll({
        strokeOpacity: 0,
        inside: true
      });
      r("AxisRendererY", ["xy", "chart", "scrollbar"]).setAll({
        strokeOpacity: 0,
        inside: true,
        minGridDistance: 5
      });
      r("AxisLabel", ["xy", "scrollbar", "x"]).setAll({
        opacity: 0.5,
        centerY: p100,
        minPosition: 0.01,
        maxPosition: 0.99,
        fontSize: "0.8em"
      });
      r("AxisLabel", ["category"]).setAll({
        text: "{category}",
        populateText: true
      });
      r("AxisLabel", ["x"]).setAll({
        centerY: 0
      });
      r("AxisLabel", ["x", "inside"]).setAll({
        centerY: p100
      });
      r("AxisLabel", ["x", "inside", "opposite"]).setAll({
        centerY: 0
      });
      r("AxisLabel", ["x", "opposite"]).setAll({
        centerY: p100
      });
      r("AxisLabel", ["y"]).setAll({
        centerX: p100
      });
      r("AxisLabel", ["y", "inside"]).setAll({
        centerX: 0
      });
      r("AxisLabel", ["y", "inside", "opposite"]).setAll({
        centerX: p100
      });
      r("AxisLabel", ["y", "opposite"]).setAll({
        centerX: 0
      });
      r("AxisLabel", ["xy", "scrollbar", "y"]).setAll({
        visible: false
      });
      // Class: Grid
      r("Grid", ["xy", "scrollbar", "y"]).setAll({
        visible: false
      });
      // Class: Grid
      r("Grid", ["xy", "scrollbar", "x"]).setAll({
        opacity: 0.5
      });
      /**
       * ------------------------------------------------------------------------
       * charts/xy: Cursor
       * ------------------------------------------------------------------------
       */
      r("XYCursor").setAll({
        behavior: "none",
        layer: 30,
        exportable: false,
        snapToSeriesBy: "xy",
        moveThreshold: 1
      });
      {
        var _rule = r("Grid", ["cursor", "x"]);
        _rule.setAll({
          strokeOpacity: 0.8,
          strokeDasharray: [2, 2],
          ariaLabel: language.translate("Use left and right arrows to move selection")
        });
        setColor(_rule, "stroke", ic, "alternativeBackground");
      }
      {
        var _rule2 = r("Grid", ["cursor", "y"]);
        _rule2.setAll({
          strokeOpacity: 0.8,
          strokeDasharray: [2, 2],
          ariaLabel: language.translate("Use up and down arrows to move selection")
        });
        setColor(_rule2, "stroke", ic, "alternativeBackground");
      }
      {
        var _rule3 = r("Graphics", ["cursor", "selection"]);
        _rule3.setAll({
          fillOpacity: 0.15
        });
        setColor(_rule3, "fill", ic, "alternativeBackground");
      }
      /**
       * ------------------------------------------------------------------------
       * charts/xy: Axes
       * ------------------------------------------------------------------------
       */
      r("Axis").setAll({
        start: 0,
        end: 1,
        minZoomCount: 1,
        maxZoomCount: Infinity,
        maxZoomFactor: 1000,
        maxDeviation: 0.1,
        snapTooltip: true,
        tooltipLocation: 0.5,
        panX: true,
        panY: true,
        zoomX: true,
        zoomY: true,
        fixAxisSize: true
      });
      r("AxisLabel").setAll({
        location: 0.5,
        multiLocation: 0,
        centerX: p50,
        centerY: p50,
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 5,
        paddingRight: 5
      });
      // The following is deprecated following text measuring updates in 5.0.5
      // r("AxisLabel", ["y"]).setAll({
      // 	textAlign: "right"
      // });
      // r("AxisLabel", ["y", "opposite"]).setAll({
      // 	textAlign: "left"
      // });
      r("Container", ["axis", "header"]).setAll({
        layer: 30
      });
      r("Rectangle", ["axis", "header", "background"]).setAll({
        crisp: true
      });
      {
        var _rule4 = r("AxisRenderer");
        _rule4.setAll({
          crisp: true,
          strokeOpacity: 0
        });
        setColor(_rule4, "stroke", ic, "grid");
      }
      r("AxisRendererX").setAll({
        minGridDistance: 120,
        opposite: false,
        inversed: false,
        cellStartLocation: 0,
        cellEndLocation: 1,
        width: p100
      });
      r("AxisRendererY").setAll({
        minGridDistance: 40,
        opposite: false,
        inversed: false,
        cellStartLocation: 0,
        cellEndLocation: 1,
        height: p100
      });
      {
        var _rule5 = r("Rectangle", ["axis", "thumb"]);
        _rule5.setAll({
          fillOpacity: 0
        });
        setColor(_rule5, "fill", ic, "alternativeBackground");
        _rule5.states.create("hover", {
          fillOpacity: 0.1
        });
      }
      r("Rectangle", ["axis", "thumb", "x"]).setAll({
        cursorOverStyle: "ew-resize"
      });
      r("Rectangle", ["axis", "thumb", "y"]).setAll({
        cursorOverStyle: "ns-resize"
      });
      {
        var _rule6 = r("Grid");
        _rule6.setAll({
          location: 0,
          strokeOpacity: 0.15,
          crisp: true
        });
        setColor(_rule6, "stroke", ic, "grid");
      }
      r("Grid", ["base"]).setAll({
        strokeOpacity: 0.3
      });
      {
        var _rule7 = r("Graphics", ["axis", "fill"]);
        _rule7.setAll({
          visible: false,
          isMeasured: false,
          position: "absolute",
          fillOpacity: 0.05
        });
        setColor(_rule7, "fill", ic, "alternativeBackground");
      }
      r("Graphics", ["axis", "fill", "range"]).setAll({
        isMeasured: true
      });
      // hides all elements of series axis range
      r("Graphics", ["series", "fill", "range"]).setAll({
        visible: false,
        isMeasured: true
      });
      r("Grid", ["series", "range"]).setAll({
        visible: false
      });
      r("AxisTick", ["series", "range"]).setAll({
        visible: false
      });
      r("AxisLabel", ["series", "range"]).setAll({
        visible: false
      });
      {
        var _rule8 = r("AxisTick");
        _rule8.setAll({
          location: 0.5,
          multiLocation: 0,
          strokeOpacity: 1,
          isMeasured: false,
          position: "absolute",
          visible: false
        });
        setColor(_rule8, "stroke", ic, "grid");
      }
      r("CategoryAxis").setAll({
        startLocation: 0,
        endLocation: 1,
        fillRule: function fillRule(dataItem, index) {
          var axisFill = dataItem.get("axisFill");
          if (axisFill) {
            if (!$type.isNumber(index) || index % 2 == 0) {
              axisFill.setPrivate("visible", true);
            } else {
              axisFill.setPrivate("visible", false);
            }
          }
        }
      });
      var gridIntervals = [{
        timeUnit: "millisecond",
        count: 1
      }, {
        timeUnit: "millisecond",
        count: 5
      }, {
        timeUnit: "millisecond",
        count: 10
      }, {
        timeUnit: "millisecond",
        count: 50
      }, {
        timeUnit: "millisecond",
        count: 100
      }, {
        timeUnit: "millisecond",
        count: 500
      }, {
        timeUnit: "second",
        count: 1
      }, {
        timeUnit: "second",
        count: 5
      }, {
        timeUnit: "second",
        count: 10
      }, {
        timeUnit: "second",
        count: 30
      }, {
        timeUnit: "minute",
        count: 1
      }, {
        timeUnit: "minute",
        count: 5
      }, {
        timeUnit: "minute",
        count: 10
      }, {
        timeUnit: "minute",
        count: 15
      }, {
        timeUnit: "minute",
        count: 30
      }, {
        timeUnit: "hour",
        count: 1
      }, {
        timeUnit: "hour",
        count: 3
      }, {
        timeUnit: "hour",
        count: 6
      }, {
        timeUnit: "hour",
        count: 12
      }, {
        timeUnit: "day",
        count: 1
      }, {
        timeUnit: "day",
        count: 2
      }, {
        timeUnit: "day",
        count: 3
      }, {
        timeUnit: "day",
        count: 4
      }, {
        timeUnit: "day",
        count: 5
      }, {
        timeUnit: "week",
        count: 1
      }, {
        timeUnit: "month",
        count: 1
      }, {
        timeUnit: "month",
        count: 2
      }, {
        timeUnit: "month",
        count: 3
      }, {
        timeUnit: "month",
        count: 6
      }, {
        timeUnit: "year",
        count: 1
      }, {
        timeUnit: "year",
        count: 2
      }, {
        timeUnit: "year",
        count: 5
      }, {
        timeUnit: "year",
        count: 10
      }, {
        timeUnit: "year",
        count: 50
      }, {
        timeUnit: "year",
        count: 100
      }, {
        timeUnit: "year",
        count: 200
      }, {
        timeUnit: "year",
        count: 500
      }, {
        timeUnit: "year",
        count: 1000
      }, {
        timeUnit: "year",
        count: 2000
      }, {
        timeUnit: "year",
        count: 5000
      }, {
        timeUnit: "year",
        count: 10000
      }, {
        timeUnit: "year",
        count: 100000
      }];
      var dateFormats = {
        "millisecond": language.translate("_date_millisecond"),
        "second": language.translate("_date_second"),
        "minute": language.translate("_date_minute"),
        "hour": language.translate("_date_hour"),
        "day": language.translate("_date_day"),
        "week": language.translate("_date_day"),
        "month": language.translate("_date_month"),
        "year": language.translate("_date_year")
      };
      var periodChangeDateFormats = {
        "millisecond": language.translate("_date_millisecond"),
        "second": language.translate("_date_second"),
        "minute": language.translate("_date_minute"),
        "hour": language.translate("_date_day"),
        "day": language.translate("_date_day"),
        "week": language.translate("_date_day"),
        "month": language.translate("_date_month") + " " + language.translate("_date_year"),
        "year": language.translate("_date_year")
      };
      var tooltipDateFormats = {
        "millisecond": language.translate("_date_millisecond_full"),
        "second": language.translate("_date_second_full"),
        "minute": language.translate("_date_minute_full"),
        "hour": language.translate("_date_hour_full"),
        "day": language.translate("_date_day_full"),
        "week": language.translate("_date_week_full"),
        "month": language.translate("_date_month_full"),
        "year": language.translate("_date_year")
      };
      r("CategoryDateAxis").setAll({
        markUnitChange: true,
        gridIntervals: $array.copy(gridIntervals),
        dateFormats: $object.copy(dateFormats),
        periodChangeDateFormats: $object.copy(periodChangeDateFormats)
      });
      r("DateAxis").setAll({
        maxZoomFactor: null,
        strictMinMax: true,
        startLocation: 0,
        endLocation: 1,
        markUnitChange: true,
        groupData: false,
        groupCount: 500,
        gridIntervals: $array.copy(gridIntervals),
        dateFormats: $object.copy(dateFormats),
        periodChangeDateFormats: $object.copy(periodChangeDateFormats),
        tooltipDateFormats: tooltipDateFormats,
        groupIntervals: [{
          timeUnit: "millisecond",
          count: 1
        }, {
          timeUnit: "millisecond",
          count: 10
        }, {
          timeUnit: "millisecond",
          count: 100
        }, {
          timeUnit: "second",
          count: 1
        }, {
          timeUnit: "second",
          count: 10
        }, {
          timeUnit: "minute",
          count: 1
        }, {
          timeUnit: "minute",
          count: 10
        }, {
          timeUnit: "hour",
          count: 1
        }, {
          timeUnit: "day",
          count: 1
        }, {
          timeUnit: "week",
          count: 1
        }, {
          timeUnit: "month",
          count: 1
        }, {
          timeUnit: "year",
          count: 1
        }],
        fillRule: function fillRule(dataItem) {
          var axisFill = dataItem.get("axisFill");
          if (axisFill) {
            var axis = dataItem.component;
            var value = dataItem.get("value");
            var endValue = dataItem.get("endValue");
            var intervalDuration = axis.intervalDuration();
            var baseInterval = axis.getPrivate("baseInterval");
            var gridInterval = axis.getPrivate("gridInterval", baseInterval);
            var min = axis.getPrivate("min", 0);
            min = $time.round(new Date(min), gridInterval.timeUnit, gridInterval.count, _this._root.locale.firstDayOfWeek, _this._root.utc, undefined, _this._root.timezone).getTime();
            if (value != null && endValue != null) {
              var val = Math.round(Math.round((value - min) / intervalDuration)) / 2;
              if (val == Math.round(val)) {
                axisFill.setPrivate("visible", true);
              } else {
                axisFill.setPrivate("visible", false);
              }
            }
          }
        }
      });
      r("GaplessDateAxis").setAll({
        fillRule: function fillRule(dataItem) {
          var axisFill = dataItem.get("axisFill");
          if (axisFill) {
            var index = dataItem.get("index");
            var visible = false;
            if (!$type.isNumber(index) || index % 2 == 0) {
              visible = true;
            }
            axisFill.setPrivate("visible", visible);
          }
        }
      });
      r("ValueAxis").setAll({
        baseValue: 0,
        logarithmic: false,
        strictMinMax: false,
        autoZoom: true,
        fillRule: function fillRule(dataItem) {
          var axisFill = dataItem.get("axisFill");
          if (axisFill) {
            var axis = dataItem.component;
            var value = dataItem.get("value");
            var step = axis.getPrivate("step");
            if ($type.isNumber(value) && $type.isNumber(step)) {
              if ($math.round(value / step / 2, 5) == Math.round(value / step / 2)) {
                axisFill.setPrivate("visible", false);
              } else {
                axisFill.setPrivate("visible", true);
              }
            }
          }
        }
      });
      r("DurationAxis").setAll({
        baseUnit: "second"
      });
      /**
       * ------------------------------------------------------------------------
       * charts/xy: Series
       * ------------------------------------------------------------------------
       */
      r("XYSeries").setAll({
        maskBullets: true,
        stackToNegative: true,
        locationX: 0.5,
        locationY: 0.5,
        snapTooltip: false,
        openValueXGrouped: "open",
        openValueYGrouped: "open",
        valueXGrouped: "close",
        valueYGrouped: "close",
        seriesTooltipTarget: "series"
      });
      r("BaseColumnSeries").setAll({
        adjustBulletPosition: true
      });
      r("ColumnSeries").setAll({
        clustered: true
      });
      r("RoundedRectangle", ["series", "column"]).setAll({
        position: "absolute",
        isMeasured: false,
        width: percent(70),
        height: percent(70),
        strokeWidth: 1,
        strokeOpacity: 1,
        cornerRadiusBL: 0,
        cornerRadiusTL: 0,
        cornerRadiusBR: 0,
        cornerRadiusTR: 0,
        fillOpacity: 1,
        role: "figure"
      });
      r("LineSeries").setAll({
        connect: true,
        autoGapCount: 1.1,
        stackToNegative: false
      });
      r("Graphics", ["series", "stroke"]).setAll({
        position: "absolute",
        strokeWidth: 1,
        strokeOpacity: 1,
        isMeasured: false
      });
      r("Graphics", ["series", "fill"]).setAll({
        visible: false,
        fillOpacity: 0,
        position: "absolute",
        strokeWidth: 0,
        strokeOpacity: 0,
        isMeasured: false
      });
      r("Graphics", ["line", "series", "legend", "marker", "stroke"]).setAll({
        draw: function draw(display, sprite) {
          var parent = sprite.parent;
          if (parent) {
            var h = parent.height();
            var w = parent.width();
            display.moveTo(0, h / 2);
            display.lineTo(w, h / 2);
          }
        }
      });
      {
        var _rule9 = r("Graphics", ["line", "series", "legend", "marker", "stroke"]).states.create("disabled", {});
        setColor(_rule9, "stroke", ic, "disabled");
      }
      r("Graphics", ["line", "series", "legend", "marker", "fill"]).setAll({
        draw: function draw(display, sprite) {
          var parent = sprite.parent;
          if (parent) {
            var h = parent.height();
            var w = parent.width();
            display.moveTo(0, 0);
            display.lineTo(w, 0);
            display.lineTo(w, h);
            display.lineTo(0, h);
            display.lineTo(0, 0);
          }
        }
      });
      {
        var _rule10 = r("Graphics", ["line", "series", "legend", "marker", "fill"]).states.create("disabled", {});
        setColor(_rule10, "stroke", ic, "disabled");
      }
      r("SmoothedXYLineSeries").setAll({
        tension: 0.5
      });
      r("SmoothedXLineSeries").setAll({
        tension: 0.5
      });
      r("SmoothedYLineSeries").setAll({
        tension: 0.5
      });
      r("Candlestick").setAll({
        position: "absolute",
        isMeasured: false,
        width: percent(50),
        height: percent(50),
        strokeWidth: 1,
        strokeOpacity: 1,
        cornerRadiusBL: 0,
        cornerRadiusTL: 0,
        cornerRadiusBR: 0,
        cornerRadiusTR: 0,
        fillOpacity: 1,
        role: "figure"
      });
      r("OHLC").setAll({
        width: percent(80),
        height: percent(80)
      });
      r("CandlestickSeries").setAll({
        lowValueXGrouped: "low",
        lowValueYGrouped: "low",
        highValueXGrouped: "high",
        highValueYGrouped: "high",
        openValueXGrouped: "open",
        openValueYGrouped: "open",
        valueXGrouped: "close",
        valueYGrouped: "close"
      });
      // These rules can be used for regular columns, too
      {
        var _rule11 = r("Rectangle", ["column", "autocolor"]).states.create("riseFromOpen", {});
        setColor(_rule11, "fill", ic, "positive");
        setColor(_rule11, "stroke", ic, "positive");
      }
      {
        var _rule12 = r("Rectangle", ["column", "autocolor"]).states.create("dropFromOpen", {});
        setColor(_rule12, "fill", ic, "negative");
        setColor(_rule12, "stroke", ic, "negative");
      }
      // Hollow
      r("Rectangle", ["column", "autocolor", "pro"]).states.create("riseFromOpen", {
        fillOpacity: 0
      });
      r("Rectangle", ["column", "autocolor", "pro"]).states.create("dropFromOpen", {
        fillOpacity: 1
      });
      {
        var _rule13 = r("Rectangle", ["column", "autocolor", "pro"]).states.create("riseFromPrevious", {});
        setColor(_rule13, "fill", ic, "positive");
        setColor(_rule13, "stroke", ic, "positive");
      }
      {
        var _rule14 = r("Rectangle", ["column", "autocolor", "pro"]).states.create("dropFromPrevious", {});
        setColor(_rule14, "fill", ic, "negative");
        setColor(_rule14, "stroke", ic, "negative");
      }
    }
  }]);
  return XYChartDefaultTheme;
}(Theme);